/**
 * Texto de ayuda que se muestra arriba de las tablas con ordenamiento, para que los usuarios
 * sepan que pueden pulsar los encabezados. Va fuera de la tarjeta (el cuadro blanco) de la tabla,
 * justo antes de ella.
 *
 * @param {string} extraClassName - Clases adicionales, por ejemplo para el espacio de arriba.
 */
const SortHelpText = ({ extraClassName = '' }) => (
  <p className={`Tables__SortHelp ${extraClassName}`.trim()}>Haz clic en los <strong>encabezados</strong> de la tabla para ordenar la información</p>
)

export { SortHelpText }
